import { useTranslation, Trans } from 'react-i18next'
import { Form, Icon, Text } from '@lounge-fe/ui-kit'
import { GenderValue } from '@lounge-fe/validation/src/schema/account'
import { SignUpFormProps } from './types'
import { useExponea } from '@/hooks/useExponea'
import { SignupValues } from '@/hooks/useExponea/types'
import { useShopify } from '@/hooks/useShopify'
import { useEffect, useState } from 'react'
import { promoSignup } from '@lounge-fe/validation/src/schema/signup'
import { CountryCode } from '@lounge-fe/ui-kit/src/components/InputPhoneNumber/types'
import { minusYears } from '@/utils/date/date'

export const SignupModalForm = ({
  email,
  onSuccess,
  eventName,
  updateBloomreachDomain = true,
}: SignUpFormProps) => {
  const { t } = useTranslation()
  const { shop, country } = useShopify()
  const { events, update, track, identify, consent } = useExponea()

  const [isLoading, setIsLoading] = useState(false)
  const [isComplete, setIsComplete] = useState(false)

  const handleSubmit = async (values: SignupValues) => {
    const emailLower = values.email.toLowerCase().trim()
    const birthday = values.birthday
      ? new Date(values.birthday).toISOString()
      : undefined

    const customer = {
      first_name: values.firstName,
      last_name: values.lastName,
      birthday,
      gender: values.gender,
    }

    const signupData = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      birthday: values.birthday,
      acceptsMarketing: values.acceptsMarketing,
      gender: values.gender,
      tags: ['footer'],
    }

    const trackData = {
      ...customer,
      email: emailLower,
      tags: ['footer'],
      consent: values.acceptsMarketing ? 'on' : 'off',
    }

    const updateData = {
      ...(updateBloomreachDomain && { domain: shop }),
      ...customer,
      birthday: birthday || null,
    }

    if (eventName) {
      identify(emailLower, {
        ...customer,
        ...(updateBloomreachDomain && { domain: shop }),
      })
      track(eventName, trackData)
      if (values.acceptsMarketing) {
        consent('email', true)
        consent('sms', true)
      }
    } else {
      events.signup(signupData)
    }

    update(updateData)

    setIsLoading(true)

    setTimeout(() => {
      setIsLoading(false)
    }, 2000)

    setTimeout(() => {
      setIsComplete(true)
    }, 2001)

    setTimeout(() => {
      onSuccess()
    }, 3000)

    //await onSuccess()
  }

  useEffect(() => {
    if (isComplete) {
      localStorage.setItem('discount_modal_closed_at', Date.now().toString())
    }
  }, [isComplete])

  return (
    <Form
      id="modal-sign-up-form"
      validationSchema={promoSignup}
      defaultValues={{ email }}
      onSubmit={handleSubmit}
      className="flex flex-col gap-6"
    >
      <div className="grid gap-4 md:gap-6 md:grid-cols-2">
        <Form.Input
          required
          name="firstName"
          placeholder={t('account.first_name')}
          testId="first-name-input"
        />
        <Form.Input
          required
          name="lastName"
          placeholder={t('account.last_name')}
          variant="underlined"
          testId="last-name-input"
        />
      </div>
      <Form.Input
        required
        name="email"
        placeholder={t('account.email_address')}
        variant="underlined"
        testId="email-input"
      />
      <Form.Date
        name="birthday"
        placeholder={t('account.date_of_birth')}
        max={minusYears(16, new Date()).toISOString().split('T')[0]}
        variant="underlined"
      />
      <Form.Checkbox
        name="acceptsMarketing"
        label={t('account.sms_email_marketing_opt_in')}
        className="justify-start"
      />
      {isComplete ? (
        <>
          <Form.Submit className="w-full text-white">
            <Icon.Tick fill="white" />
          </Form.Submit>
        </>
      ) : (
        <>
          <Form.Submit
            isLoading={isLoading}
            className="w-full"
            testId="submit-button"
          >
            {t('action.sign_up')}
          </Form.Submit>
        </>
      )}

      <Text variant="body-xs">
        <Trans
          i18nKey="account.privacy_policy_statement"
          components={{ a: <a /> }}
        />
      </Text>
    </Form>
  )
}
